import React from 'react'
import { LinkWrapper } from './style'

const AppNavLink = ({ children, ...rest }) => {
  return (
    <LinkWrapper activeClassName='active' {...rest}>
      {children}
    </LinkWrapper>
  )
}

export default AppNavLink
